module.exports = __webpack_public_path__ + "components/tide-header/static/icon-tide-datum-b8ee6817c2992e103935579e4adbc7ec.svg";